export var ExchangeAction;
(function (ExchangeAction) {
    ExchangeAction["BUY"] = "BUY";
    ExchangeAction["SELL"] = "SELL";
})(ExchangeAction || (ExchangeAction = {}));
//# sourceMappingURL=exchange-action.enum.js.map